export default __webpack_public_path__ + "fa045ae4c614164b5e3477dd86c7a29c.svg";